import { createFileRoute } from '@tanstack/react-router';

import Arena from '@/features/arena/arena';
import { littlebirdSdk } from '@/lib/sdk-init';

export const Route = createFileRoute('/_authenticated/arena/')({
  onEnter() {
    void littlebirdSdk.stores.arenas.ensureListLoadedFromStorage();
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <Arena />;
}
